import type { RootState } from 'store'

export const getSort = (state: RootState) => state?.retailBuyersWine?.sorting
export const getPageInfo = (state: RootState) =>
  state?.retailBuyersWine?.pageInfo ?? null
export const getLoading = (state: RootState) => state?.retailBuyersWine?.loading
export const getError = (state: RootState) => state?.retailBuyersWine?.error
export const getItems = (state: RootState) => state?.retailBuyersWine?.items
export const getQuery = (state: RootState) =>
  state?.retailBuyersWine?.query ?? ''
export const getFilters = (state: RootState) =>
  state?.retailBuyersWine?.filters ?? []
export const getCurrency = (state: RootState) =>
  state?.retailBuyersWine?.currency ?? null
export const getCategory = (state: RootState) =>
  state?.retailBuyersWine?.category ?? null
export const getCountry = (state: RootState) =>
  state?.retailBuyersWine?.country ?? null
export const getCompany = (state: RootState) =>
  state?.retailBuyersWine?.company ?? null
